import { Routes, Route, Outlet } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Teams from "./pages/Teams";
import TeamDetail from "./pages/TeamDetail";
import Sponsoren from "./pages/Sponsoren";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminNews from "./pages/admin/News";
import AdminTeams from "./pages/admin/Teams";
import AdminSponsoren from "./pages/admin/Sponsoren";
import AdminEinstellungen from "./pages/admin/Einstellungen";
import ProtectedRoute from "./cms/ProtectedRoute";
import AdminLayout from "./cms/AdminLayout";

/** Öffentliche Seite: Navbar + Footer drumrum */
function OeffentlichesLayout() {
  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<OeffentlichesLayout />}>
          <Route path="/"            element={<Home />} />
          <Route path="/news"        element={<News />} />
          <Route path="/news/:slug"  element={<NewsDetail />} />
          <Route path="/teams"       element={<Teams />} />
          <Route path="/teams/:id"   element={<TeamDetail />} />
          <Route path="/sponsoren"   element={<Sponsoren />} />
          <Route path="/kontakt"     element={<Kontakt />} />
          <Route path="/impressum"   element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*"            element={<NotFound />} />
        </Route>

        {/* Redaktion / CMS — eigenes Layout, kein öffentlicher Navbar/Footer */}
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="/admin"                element={<AdminDashboard />} />
          <Route path="/admin/news"           element={<AdminNews />} />
          <Route path="/admin/teams"          element={<AdminTeams />} />
          <Route path="/admin/sponsoren"      element={<AdminSponsoren />} />
          <Route path="/admin/einstellungen"  element={<AdminEinstellungen />} />
        </Route>
      </Routes>
    </>
  );
}
